"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("./object");
var string_1 = require("./string");
var handleCurry_1 = require("./utils/handleCurry");
var description_1 = require("./utils/description");
var symbol_1 = require("./symbol");
function hasOwnProperty(property, object) {
    if (!string_1.default(property) && !symbol_1.default(property)) {
        throw new TypeError('Property name must be a string');
    }
    return handleCurry_1.default.call(this, arguments, description_1.setDescription(function (object) {
        return object_1.default(object) && Object.prototype.hasOwnProperty.call(object, property);
    }, 'an object with own ' + (symbol_1.default(property) ? property.toString() : '"' + property + '"') + ' property'));
}
exports.default = hasOwnProperty;
